import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CaptionService } from '../../../../utils/shared-services/caption.service';

@Component({
    selector: 'confirm-cancel-dialog',
    templateUrl: './src/app/features/price-change/templates/dialogs/confirm-cancel-dialog.html',
    standalone: false
})
export class ConfirmCancelDialogComponent {


    public captions: Record<string, string>


    constructor(
        @Inject(MatDialogRef) public dialogRef: MatDialogRef<ConfirmCancelDialogComponent>,
        @Inject(CaptionService) private captionService: CaptionService,
    ) {
        this.captions = this.captionService.captions;

    }

    onYes() {
        this.dialogRef.close(true);
    }

    onNo() {
        this.dialogRef.close(false);
    }
}